/**
 * Route: /splits/create — Story 2.3-UI (Split-Editor)
 *
 * Editor-Formular fuer eine neue Provisions-Regel
 * (POST /api/v2/host_split_rules) mit Live-Vorschau.
 *
 * `host_id` (optional): Story frontend-host-form (#4) — Deep-Link aus der
 * Host-Detailansicht, damit dort eine Zuweisungsmoeglichkeit fuer Hotspots
 * besteht, ohne die Zuordnungs-Logik im Host-Formular zu duplizieren.
 * Ungueltige Werte fallen still auf "kein Host vorbelegt" zurueck (.catch).
 */
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { SplitRuleEditor } from '../features/splits/SplitRuleEditor'

export const splitCreateSearchSchema = z.object({
  host_id: z.coerce.number().int().positive().optional().catch(undefined),
})

export const Route = createFileRoute('/_auth/splits/create')({
  validateSearch: splitCreateSearchSchema,
  component: SplitCreateRoute,
})

function SplitCreateRoute() {
  const { host_id } = Route.useSearch()
  return <SplitRuleEditor mode="create" defaultHostId={host_id} />
}
